import {GlobalAnalyticsVariablesInterface, TrackBackendUserErrorsInterface} from '../interfaces';
import {retrieveMergeResponseGlobalVarsCase} from './retrieve-merge-response-global-vars.case';

export const trackBackendUserErrorsPayloadCase = (
  payload: any,
  globalVariables?: GlobalAnalyticsVariablesInterface,
): TrackBackendUserErrorsInterface => {
  const data = {
    eventType: 'pageError',
    errorName: payload.statusWarning ?? '',
    errorMsg: payload.statusMessage,
    errorCode: payload.statusCode
  };
  return retrieveMergeResponseGlobalVarsCase(true, data, globalVariables);
};
